<template>
  <div class="homeIndex">
    <!-- 弹框 -->
    <div class="addInfo">
      <div>
        <span class="infoName">用户管理</span>
      </div>
      <div class="addBtn">
        <el-input placeholder="请输入昵称(回车搜索)" suffix-icon="el-icon-search" v-model="search_nick_name" clearable @keydown.enter.native="updateUserTable()" style="width:200px"></el-input>
        <el-input placeholder="请输入手机号(回车搜索)" suffix-icon="el-icon-search" v-model="search_phone" clearable @keydown.enter.native="updateUserTable()" style="width:200px; margin:0 20px"></el-input>
        <el-button type="primary" @click="addUser" round>+ 新增</el-button>
        <el-dialog title="新增用户" :visible.sync="dialogFormVisible1" :before-close="beforeClose" v-if="dialogFormVisible1" :close-on-click-modal="false">
          <el-form
            :model="userForm"
            ref="subUserForm"
            :rules="userFormValidate"
            :label-width="formLabelWidth"
          >
            <el-form-item label="用户名：" prop="userName">
              <el-input v-model="userForm.userName" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="昵称：" prop="nickName">
              <el-input v-model="userForm.nickName" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="密码：" prop="password">
              <el-input v-model="userForm.password" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="手机号：" prop="mobile">
              <el-input v-model="userForm.mobile" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="代理商：" prop="companyId">
              <el-select style="width:100%" clearable filterable
                v-model="userForm.companyId"
                placeholder="请选择代理商"
              >
                <el-option
                  v-for="item in companys"
                  :key="item.id"
                  :label="item.companyName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="权限：" prop="userType">
              <el-select style="width:100%" clearable filterable
                v-model="userForm.userType"
                placeholder="请选择管理权限"
              >
                <el-option
                  v-for="item in userTypes"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="info" @click="cancelClick('subUserForm')" class="">取 消</el-button>
            <el-button type="primary" @click="confirmClick('subUserForm')" class="submit" :loading="loadingsubmit">{{confirmText}}</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
    <!-- 表格 -->
    <div class="tableInfo">
      <el-table v-loading="loading" :data="tableData" border style="width: 100%" :header-cell-style="{color: '#333'}"
      element-loading-background = "rgba(255, 255, 255, .5)" element-loading-text = "加载中，请稍后..." element-loading-spinner = "el-icon-loading">
        <el-table-column prop="userName" label="用户名" min-width="130">
        </el-table-column>
        <el-table-column prop="nickName" label="昵称" min-width="130">
        </el-table-column>
        <el-table-column prop="mobile" label="手机号" width="130">
        </el-table-column>
        <el-table-column prop="company.companyName" label="代理商" width="120">
        </el-table-column>
        <el-table-column prop="company.userType" label="权限" width="120"> 
          <template slot-scope="scope">
            <span v-if="scope.row.company.userType === 0">施工人员</span>
            <span v-if="scope.row.company.userType === 1">管理员</span>
        </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" min-width="200">
          <template slot-scope="{row}">
            <el-button type="text" size="small" @click="editUser(row)" class="edit">修改</el-button>
            <el-divider direction="vertical"></el-divider>
            <el-button @click="delUser(row)" type="text" size="small" class="delete">删除</el-button>
            <el-divider direction="vertical"></el-divider>
            <el-button @click="grantProject(row)" type="text" size="small" class="grant"
            v-if="row.company.userType === 0">授权项目</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 编辑弹窗 -->
      <el-dialog title="修改用户" :visible.sync="dialogFormVisible2" :before-close="beforeClose" v-if="dialogFormVisible2" :close-on-click-modal="false">
        <el-form :model="userForm" ref="subUserForm" :rules="userFormValidate" :label-width="formLabelWidth">
          <!-- <el-form-item
            label="用户名："
            prop="userName"
          >
            <el-input v-model="userForm.userName" autocomplete="off" disabled></el-input>
          </el-form-item> -->
          <el-form-item label="昵称：" prop="nickName">
            <el-input v-model="userForm.nickName" autocomplete="off" ></el-input>
          </el-form-item>
          <el-form-item label="手机号：" prop="mobile">
            <el-input v-model="userForm.mobile" autocomplete="off" ></el-input>
          </el-form-item>
          <!-- <el-form-item label="代理商：" prop="companyId">
              <el-select
                v-model="userForm.companyId"
                placeholder="请选择代理商"
                disabled
              >
                <el-option
                  v-for="item in companys"
                  :key="item.id"
                  :label="item.companyName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="权限：" prop="userType">
              <el-select style="width:100%" clearable filterable
                v-model="userForm.userType"
                placeholder="请选择管理权限"
              >
                <el-option
                  v-for="item in userTypes"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="info" @click="cancelClick('subUserForm')">取 消</el-button>
          <el-button type="primary" @click="confirmClick('subUserForm')" class="submit" :loading="loadingsubmit">{{confirmText}}</el-button>
        </div>
      </el-dialog>

      <!-- 授权弹窗 -->
      <el-dialog title="授权项目" :visible.sync="dialogFormVisible3" class="tabDailog" :close-on-click-modal="false">
        <el-form size="small" class="CloudSetting" :model="form" ref="grantRef" :rules="grantRules">
          <el-tabs type="border-card" class="table-switch"  @tab-click="chooseAgent" v-model="cloudName">
            <el-tab-pane v-for="(item,index) in cloudConfigs" :name="item.cloudName" :label="item.cloudName" :key="index">
              <el-form-item label="项目：" :label-width="formLabelWidth">
                <!-- <el-checkbox-group v-model="projectNames[index]" @change="changeProjects">
                  <el-checkbox v-for="(item,index) in projects" :label="item.id" :key="index">{{item.projectName}}</el-checkbox>
                </el-checkbox-group> -->
                <el-select v-if="is_show" v-model="projectNames[index]" multiple  style="width:100%;" clearable filterable placeholder="请选择" @change="changeProjects" class="project_select">
                  <el-option
                    v-for="item in projects"
                    :key="item.id"
                    :label="item.projectName"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-tab-pane>
          </el-tabs>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="info" @click="cancelBtn">取 消</el-button>
          <el-button type="primary" @click="grantBtn('grantRef')">授 权</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        background
        @size-change="changeSize"
        @current-change="changePage"
        :current-page="page.pageNum"
        :page-sizes="page_size_list"
        :page-size="page.pageSize"
        layout="prev, pager, next, sizes, total, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
//引入userInfo接口
import { userInfo } from "@/api";
//添加用户信息
import { addUserInfo, delUserInfo,selectInfo,editUserInfo,cloudConfigsTabs,grantProjects,authorizationUserProject,viewAuthorizedProjects } from "@/api";
const api = require("@/api");
console.log(userInfo);
export default {
  data() {
    // 手机号验证
    var checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[3|4|5|6|7|8|9][0-9]{9}$/
      if (!value) {
        return callback(new Error('电话号码不能为空'))
      }
      setTimeout(() => {
        if (!Number.isInteger(+value)) {
          callback(new Error('请输入数字值'))
        } else {
          if (phoneReg.test(value)) {
            callback()
          } else {
            callback(new Error('电话号码格式不正确'))
          }
        }
      }, 100)
    };
    return {
      search_nick_name: '',
      search_phone: '',
      is_show: false,
      num: 0,
      loading: false,
      loadingsubmit: false,
      confirmText: '确定',
      //dialog
      apiName: "",
      successMsg: "",
      errorMsg: "",
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      userForm: {
        id: "",
        mobile: "",
        nickName: "",
        userName: "",
        password: '',
        userType: '',
        companyId: ''
      },
      form: {
        projectNames: [],
      },
      userType: '',
      companyId: '',
      userFormValidate: {
        userName: [
          {required: true,message: '请输入用户名',trigger: 'blur'},
          {
            validator: function(rule, value, callback) {
              if (/^[A-Za-z0-9-_\u4e00-\u9fa5]{2,30}$/.test(value) == false) {
                callback(new Error("只能输入2-30个中文、字母、数字、中划线、下划线"));
              } else {
                //校验通过
                callback();
              }
            },
            trigger: "blur"
          }
          // {pattern: /^(\w){2,11}$/, message: '只能输入2-11个字母、数字、下划线'}
        ],
        // password: [{ validator: validatePwd, trigger: "blur" }],
        password: [
          {required: true,message: '请输入密码',trigger: 'blur'}, 
          { min: 5,max: 25,message: '长度在 5 到 25个字符'}, 
          {pattern: /^(\w){5,25}$/, message: '只能输入5-25个字母、数字、下划线'}
        ],
        nickName: [
          { required: true, message: "请输入昵称", trigger: "blur",},
          {
            validator: function(rule, value, callback) {
              if (/^[A-Za-z0-9-_\u4e00-\u9fa5]{2,30}$/.test(value) == false) {
                callback(new Error("只能输入2-30个中文、字母、数字、中划线、下划线"));
              } else {
                //校验通过
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        mobile: [
          { required: true, validator: checkPhone, trigger: "blur",},//'blur'是鼠标失去焦点的时候会触发验证
          // { min: 11, message: '长度在 2 到 7 个字符'}
        ],
        userType: [
          {required: true, message: "请选择用户类型", trigger: "change",},
        ],
        companyId: [
          {required: true, message: "请选择代理商", trigger: "change",},
        ],
      },
      grantRules:{},
      formLabelWidth: "100px",
      cloudConfigs: [],
      cur: 0 ,//默认选中第一个tab
      companyName: '',
      projects: [],
      projectNames: [],
      projectName: null,
      authorizeProjects:[],
      cloudName: '',
      //table
      tableData: [],
      //分页参数
      page: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      page_size_list: [10,20,30],
      //公司选择
      companys: [],
      //管理权限选择
      userTypes:[{'id':0,'name':'施工人员'},{'id':1,'name':'管理员'}],
      cloudId: null,
      clouds_projects: [],
      cloud_project: {},
      userId: null,
      arr: [],
      arr1: []
    };
  },
  methods: {
    //table
    // 渲染表单数据
    updateUserTable(pageList) {
      this.loading = true
      let page = pageList;
      userInfo("", this.search_nick_name, this.search_phone, "","",page).then((res) => {
        console.log('userInfo',res);
        if (res.data.code == '0') {
          this.tableData = res.data.data;
          this.total = res.data.count;
        } else {
          this.$message.warning(res.data.message);
        }
        this.loading = false
      })
      .catch((err) => {
        this.loading = false
        console.log(err);
        this.$message.error("用户管理获取数据出错或网络错误");
      });
    },
    //dailog对话框
    confirmClick(formName){
      this.loadingsubmit = true
      this.confirmText = "提交中..."
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          //本地表单校验通过，将表单信息提交到后台
          //调用增加信息接口
          api[this.apiName](this.userForm)
            .then((res) => {
              if (res.data.code == '0') {
                //关闭dailog
                this.dialogFormVisible1 = false;
                this.dialogFormVisible2 = false;
                //提示添加成功，更新表格数据
                this.$message.success(this.successMsg);
                this.updateUserTable(this.page);
              } else {
                this.$message.warning(res.data.message);
              }
            })
            .catch((err) => {
              console.log(err);
              this.$message.error(res.data.message);
            })
            .finally(()=>{
              this.loadingsubmit = false
              this.confirmText = "确定"
              loading.close();
            })
        } else {
          this.loadingsubmit = false
          this.confirmText = "确定"
          this.$message.error("表单校验不通过");
        }
      });
    },
    grantBtn(formName){
      this.$refs[formName].validate((valid)=>{
        if(valid){
          if(Object.keys(this.cloud_project).length > 0){
            this.clouds_projects.push(this.cloud_project)
          }
          let clouds_projects1 = []
          clouds_projects1 = this.reverse(this.clouds_projects)
          const cache = [];
          for (const t of clouds_projects1) {
            // 检查缓存中是否已经存在
            if (cache.find(c => c.cloudId === t.cloudId)) {
              // 已经存在说明以前记录过，现在这个就是多余的，直接忽略
              continue;
            }
            // 不存在就说明以前没遇到过，把它记录下来
            cache.push(t);
          }
          let data = {
            cloudProjects: cache,
            userId: this.userId
          }
          this.dialogFormVisible3 = false
          authorizationUserProject(data).then(res=>{
            if(res.data.code == '0'){
              this.$message.success(res.data.message)
            }else{
              this.$message.warning(res.data.message)
            }
          })
          .catch(err=>{
            console.log(err);
            this.$message.error(err.data.message)
          })
        }
        else{
          this.$message.error("表单验证不通过")
        }
      })
    },
    //对话框取消按钮
    cancelClick(formName) {
      this.dialogFormVisible1 = false;
      this.dialogFormVisible2 = false;
    },
    cancelBtn(){
      this.dialogFormVisible3 = false
    },
    beforeClose() {
      this.dialogFormVisible1 = false;
      this.dialogFormVisible2 = false;
    },
    //新增用户信息
    addUser() {
      //清空表单数据
      // Object.keys(this.userForm).forEach(
      //   (key) => (this.userForm[key] = "")
      // );
      this.userForm = {}
      this.dialogFormVisible1 = true;
      this.apiName = "addUserInfo";
      this.successMsg = "添加成功";
      this.errorMsg = "添加失败";
      if(this.$refs['subUserForm'] !== undefined){
        this.$refs['subUserForm'].resetFields()
      }
      // this.$refs['subUserForm'].clearValidate(); // 仅清除验证
    },
    //删除用户信息
    delUser(row) {
      //删除的一整行数据
      console.log(row);
      if (row && row.id) {
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          //调用删除请求
          delUserInfo(row.id)
            .then((res) => {
              if (res.data.code == '0') {
                console.log(res);
                this.$message.success("删除成功");
                //更新表格
                this.updateUserTable(this.page);
              } else {
                this.$message.warning(res.data.message);
              }
            })
            .catch((err) => {
              console.log(err);
              this.$message.error(err.data.message);
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      }else{
        this.$message.error("无法删除")
        return
      } 
    },
    //编辑用户信息
    editUser(row) {
      //弹出dailog
      this.dialogFormVisible2 = true;
      //数据回显
      row.companyId = row.company.id
      row.userType = row.company.userType
      this.userForm = { ...row };
      this.apiName = "editUserInfo";
      this.successMsg = "修改成功";
      this.errorMsg = "修改失败";
      // this.$refs['subUserForm'].clearValidate(); // 仅清除验证
    },
    //改变分页
    changePage(page) {
      // console.log(page);
      this.page.pageNum = page;
      this.updateUserTable(this.page);
    },
    changeSize(val) {
      // console.log(page);
      this.page.pageSize = val;
      this.updateUserTable(this.page);
    },
    //公司选择
    companySelect(){
      selectInfo()
        .then(res=>{
          console.log(res,"公司列表");
          if(res.data.code == 0){
            this.companys = res.data.data
          }
          else{
            this.$message.warning(res.data.message)
          }
        })
        .catch(err=>{
          this.$message.error(res.data.message)
        })
    },
    //授权项目
    async grantProject(row){
      this.cloudConfigs = []
      this.clouds_projects = []
      this.projectNames = []
      this.form = {}
      console.log('grantProject',row);
      this.userId = row.id
      let id = row.company.id
      this.dialogFormVisible3 = true
      await cloudConfigsTabs(id).then(res=>{
        console.log("代理商信息",res,);
        if(res.data.code == "0"){
          this.cloudConfigs = res.data.data.cloudConfigs
          let cloudConfigs1 = []
          cloudConfigs1 = res.data.data.cloudConfigs
          for (let key in this.cloudConfigs) {
            this.$set(this.projectNames, key, [])
          }
          this.companyName = res.data.data.companyName
          this.cloudName = this.cloudConfigs[0].cloudName
          this.cloudId = this.cloudConfigs[0].id
          this.is_show = false
          this.projectList(this.cloudConfigs[0].id,this.companyName)
          // setTimeout(() => {
            this.authorized_projects(cloudConfigs1)
          // }, 1500);
        }
        else{
          this.$message.warning(res.data.message)
        }
      })
      .catch(err=>{
        console.log(err);
        this.$message.error(res.data.message)
      })
    },
    //查看授权项目
    authorized_projects(cloudConfigs1){
      viewAuthorizedProjects(this.userId).then(res=>{
        console.log("云管理下的代理商的项目",res,);
        if(res.data.code == '0'){
          let datas = res.data.data
          if(datas.length !== 0){
            let data1 = []
            datas.forEach(item=>{
              let obj1 = {
                cloudId: item.cloudId,
                projectIds: item.projectId
              }    
              data1.push(obj1)
            })
            data1 = this.merge_arr(data1)
            let data2 = []
            cloudConfigs1.forEach(item1=>{
              for(var i = 0; i < data1.length; i++){
                if(data1[i].cloudId == item1.id){
                  data2.push(data1[i].projectIds)
                  return
                }
                else if(data1[i].cloudId !== item1.id && i == data1.length-1){
                  data2.push([])
                }
              }
            })
            this.projectNames = data2
            this.clouds_projects = data1
            console.log("clouds_projects",this.clouds_projects)
            console.log("projectNames",this.projectNames)
          }
        }
        else{
          this.$message.warning(res.data.message)
        }
      })
    },
    //合并数组对象
    merge_arr(arr){
      let flag_arr = []
      let result = arr.reduce((pre,cur)=>{
        if(flag_arr.indexOf(cur.cloudId) !== -1){        
          pre[flag_arr.indexOf(cur.cloudId)].projectIds.push(cur.projectIds);
        }else{
          flag_arr.push(cur.cloudId)
          cur.projectIds = [cur.projectIds]
          pre.push(cur)
        }
        return pre
      },[])
      return result
    },
    //反转数组对象
    reverse(array) {
      let newArr = [];
      for (let i = array.length - 1; i >= 0; i--) {
        newArr[newArr.length] = array[i];
      }
      return newArr;
     },
    //选择云管理
    chooseAgent(tab, event) {
      if(Object.keys(this.cloud_project).length > 0){
        this.clouds_projects.push(this.cloud_project)
      }
      this.cloudConfigs.forEach(item=>{
        if(tab.name === item.cloudName){
          this.cloudId = item.id
        }
      })
      this.is_show = false
      this.projectList(this.cloudId,this.companyName)
      
    },
    //根据云管理的项目列表
    projectList(id,companyName){
      this.projects = []
      let data = {
        cloudConfigId: id,
        companyName: companyName
      }
      grantProjects(data).then(res=>{
        this.is_show = true
        if(res.data.code == "0"){
          this.projects = res.data.data
        }
        else{
          this.$message.warning(res.data.message)
        }
      })
      .catch(err=>{
        console.log(err);
        this.$message.error(res.data.message)
      })
    },
    //选择项目
    changeProjects(event){
      console.log("选择项目",event,);
      let cloud_project = {
        cloudId: this.cloudId,
        projectIds: event
      }
      this.cloud_project = cloud_project
    },
  },
  mounted() {
    //更新表格数据
    this.updateUserTable(this.page);
    //加载公司
    this.companySelect()
  },
};
</script>

<style scoped>
.homeIndex {
  width: 100%;
  height: 100%;
  font-family: PingFang SC;
}

.addInfo {
  width: 100%;
  height: 80px;
  border-radius: 10px 10px 0 0;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  box-sizing: border-box;
}
.infoName{
  font-weight: 600;
  margin-right: 20px;
  font-size: 18px;
}
.submit{
  background: #455AF7;
  border-color: #455AF7;
}
.homeIndex .el-button.is-round{
  width: 70px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #455AF7;
  border-radius: 5px;
}
.el-button--small, .el-button--small.is-round{
    padding: 3px 3px;
}
.addBtn{
  display: flex;
}
.tableInfo{
  width: 100%;
  padding: 0 20px 20px 20px;
  box-sizing: border-box;
  background: #fff;
}
.tableInfo >>> .el-table td,
.tableInfo >>> .el-table th {
  text-align: center !important;
}
.tableInfo >>> th{
  background: #F2F3F7;
}

/* 上传logo边框未设置 */
/* 弹出框 */
.homeIndex >>> .el-dialog{
  width: 40%;
  background:  #F2F3F7;
}
.homeIndex >>> .el-dialog__header{
  display: flex;
  justify-content: center;
  font-weight: 549;
  /* background: #fff; */
  
}
.homeIndex >>> .el-dialog__body{
  padding: 0!important;
}
.el-form{
  background: #fff;
  padding: 20px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.homeIndex >>> .el-dialog__footer{
  /* background: #fff; */
  padding: 0 15px 15px 15px!important;
  
}
.el-form-item{
  width: 85%;
}
.homeIndex >>> .el-select{
  width: 100%;
}
.homeIndex >>> .el-form-item__content{
  margin-left: 80px;
}
.dialog-footer{
  /* background: #fff; */
  padding: 10px ;
}
/* .tabDailog >>> .el-select{
  height: 50px;
}
.tabDailog >>> .el-input__inner{
  height: 50px;
} */
.project_select{
  /* height: 60px!important; */
}
/* 分页 */
.pagination {
  width: 100%;
  height: 80px;
  background: #fff;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 20px;
  box-sizing: border-box;
}
.pagination >>> .el-pagination.is-background .el-pager li:not(.disabled).active{
  background: #455AF7!important;
}
/* 下拉选择 */
.homeIndex .el-input{
  width: 100%;
}

.edit{
  color: #455AF7!important;
}
.grant{
  color: #455AF7!important;
}
.delete{
  color: #FB3F4E!important;
}

.tabDailog >>> .el-tabs--border-card{
  width: 100%;
  height: 100%;
  box-shadow: none;
  border: none;
}


.tabDailog >>> .el-form{
  padding: 0;
  padding-bottom: 20px;
}
</style>
    



// WEBPACK FOOTER //
// src/pages/Home/userManagement/index.vue